import { useState, useRef } from 'react';
import useClickOutside from 'hooks/useClickOutside';
import type { EventData } from 'services/Gtm/entities';
import CrashCourseFilterSection, { type FilterSection, type FilterValue } from './CrashCoursesFilterSection/index';
import CrashCourseDropdown from './CrashCoursesDropdown/index';

export interface CrashCourseFiltersProps {
  className?: string;
  label?: string;
  isDropdown?: boolean;
  filters: FilterSection[];
  trackingData: EventData;
  onChange: (value: FilterValue, checked: boolean) => void;
}

const CrashCourseFilters = ({
  filters,
  onChange,
  className = 'crash-course-filters',
  label = 'Filters',
  isDropdown = false,
  trackingData,
}: CrashCourseFiltersProps) => {
  const [isOpened, setIsOpened] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLSpanElement>(null);
  useClickOutside(dropdownRef, () => setIsOpened(false));

  const handleFilterChange = (filter: FilterValue, checked: boolean) => {
    onChange(filter, checked);
    setIsOpened(false);
  };

  return (
    <div className={className}>
      {isDropdown ? (
        <CrashCourseDropdown
          label={label}
          trackingData={trackingData}
          ref={dropdownRef}
          isOpened={isOpened}
          onOpen={() => setIsOpened(!isOpened)}
        >
          <CrashCourseFilterSection
            onChange={(filter, checked) => handleFilterChange(filter, checked)}
            filters={filters}
            inDropdown={isDropdown}
            trackingData={trackingData}
          />
        </CrashCourseDropdown>
      ) : (
        <CrashCourseFilterSection
          onChange={onChange}
          filters={filters}
          trackingData={trackingData}
        />
      )}
    </div>
  );
};

export default CrashCourseFilters;
